import { FormCommonProps } from "../../../common/forms/types";
import i18n from "i18next";
import { PurchaseRequestApi } from "src/api/generated/erp/purchase/purchaseRequest/purchaseRequestApi";
import { AavoForm } from "src/components/common/forms/AavoForm.tsx";
import { FormCheckbox } from "src/components/common/forms/fields/FormCheckbox";
import { FormDateField } from "src/components/common/forms/fields/FormDateField";
import { useForm } from "react-hook-form";
import { requireRule } from "src/components/common/forms/validation";
import { IsoDateString } from "src/types/dateTime.ts";

export interface PurchaseOrderFromPurchaseRequestFormProps extends FormCommonProps<void> {
	purchaseRequestIds: number[];
}

interface FieldValues {
	purchaseRequestIds: Array<number>;
	plannedArrivalDate: IsoDateString;
	sumSamePartRequests: boolean;
}

export const PurchaseOrderFromPurchaseRequestForm = ({
	purchaseRequestIds,
	onFormEdited,
	...other
}: PurchaseOrderFromPurchaseRequestFormProps) => {
	const {
		control,
		handleSubmit,
		formState: { isDirty },
		watch,
	} = useForm<FieldValues>({
		mode: "all",
		defaultValues: {
			purchaseRequestIds: purchaseRequestIds,
			plannedArrivalDate: undefined,
			sumSamePartRequests: false,
		},
	});

	if (onFormEdited) watch(onFormEdited);

	return (
		<AavoForm
			handleSubmit={handleSubmit}
			isDirty={isDirty}
			columns={1}
			submit={PurchaseRequestApi.createPurchaseOrderFromSelectedPurchaseRequests}
			{...other}
		>
			<FormDateField
				control={control}
				name={"plannedArrivalDate"}
				label={i18n.t("planned_arrival_date")}
				rules={requireRule()}
				disablePast
			/>
			<FormCheckbox
				control={control}
				name={"sumSamePartRequests"}
				label={i18n.t("sum_the_requests_of_the_equal_part")}
			/>
		</AavoForm>
	);
};
